import { Link } from '@mui/material'
import parse, { DOMNode, Element } from 'html-react-parser'
import { useFlags } from 'launchdarkly-react-client-sdk'

import { useLanguage } from '../hooks/use-language'

import { Banner } from './Banner'

type DynamicBannerProps = Readonly<{
  pageKey: string
}>

const getTextContent = (children: any[] | undefined): string => {
  return children?.[0]?.type === 'text' ? children[0].data : ''
}

export const DynamicBanner: React.FC<DynamicBannerProps> = ({ pageKey = '' }) => {
  const currentLocale = useLanguage()
  const { banner } = useFlags()

  const bannerCopy = banner?.copy?.[currentLocale]
  const bannerLink = banner?.link?.[currentLocale]
  const allowedPages = banner?.pages

  if (!bannerCopy) {
    return null
  }

  if (!allowedPages || !allowedPages.includes(pageKey)) {
    return null
  }

  const parsedContent = parse(bannerCopy, {
    replace(domNode: DOMNode) {
      if (domNode instanceof Element) {
        const { name, children } = domNode

        if (name === 'a') {
          if (bannerLink) {
            return (
              <Link
                href={bannerLink}
                target="_blank"
                // @ts-ignore The variant exists stop
                variant="subtitleLink"
              >
                {getTextContent(children)}
              </Link>
            )
          } else {
            // Hide the link content when no bannerLink is available
            return <></>
          }
        }

        if (name === 'b') {
          return <strong>{getTextContent(children)}</strong>
        }

        if (name === 'i') {
          return <em>{getTextContent(children)}</em>
        }
      }
    },
  })

  return (
    <Banner>
      <>{parsedContent}</>
    </Banner>
  )
}
